export var mapFiltersTitle = function (id, dictionary, isCFU) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (isCFU === void 0) { isCFU = false; }
    if (!id || !dictionary)
        return "";
    switch (id) {
        case "moduleAreas":
            return isCFU
                ? (_a = dictionary.teachingSubject) !== null && _a !== void 0 ? _a : ""
                : (_b = dictionary.professionalInterest) !== null && _b !== void 0 ? _b : "";
        case "educationType":
        case "educationTypes":
            return (_c = dictionary.educationType) !== null && _c !== void 0 ? _c : "";
        case "place":
        case "places":
            return (_d = dictionary.place) !== null && _d !== void 0 ? _d : "";
        case "educationBegins":
            return (_e = dictionary.educationBegins) !== null && _e !== void 0 ? _e : "";
        case "language":
        case "languages":
            return (_f = dictionary.language) !== null && _f !== void 0 ? _f : "";
        case "time":
            return (_g = dictionary.pointInTime) !== null && _g !== void 0 ? _g : "";
        case "suppliers":
            return (_h = dictionary.supplier) !== null && _h !== void 0 ? _h : "";
        case "teachingMethod":
        case "teachingMethods":
            return (_j = dictionary.teachingMethod) !== null && _j !== void 0 ? _j : "";
        case "academicLevel":
            return (_k = dictionary.academicLevel) !== null && _k !== void 0 ? _k : "";
        case "academicArea":
            return (_l = dictionary.academicArea) !== null && _l !== void 0 ? _l : "";
        case "exchangeType":
            return (_m = dictionary.exchangeType) !== null && _m !== void 0 ? _m : "";
        case "startOfTerm":
            return (_o = dictionary.startOfTerm) !== null && _o !== void 0 ? _o : "";
    }
    return "´__No title translation";
};
